import React, { Component } from 'react';
import Headroom from 'react-headroom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Grid,
  Row,
  Col,
  css,
  styled,
  thd,
  withTheme,
  up,
} from '@smooth-ui/core-sc';
import HeaderLogo from 'theme/rsr-logo-header.svg';

const CustomHeadroom = styled(Headroom)`
  .headroom {
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
  .headroom--unfixed {
    position: relative;
    transform: translateY(0);
  }
  .headroom--scrolled {
    transition: transform 200ms ease-in-out;
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(-100%);
  }
  .headroom--pinned {
    position: fixed;
    transform: translateY(0%);
  }
`;

const HeaderWrapper = styled.div`
  background-color: ${thd('primary', 'darkgrey')};
  padding-top: 20px;
  width: 100%;
  padding-left: 10px;
  height: 98px;
  img {
    height: 38px;
    height: auto;
    width: 120px;
  }
`;

const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  height: 57px;
  justify-content: flex-start;
  max-width: 100%;
  width: 100%;
  img {
    height: 35px;
    height: auto;
    width: 176px;
  }
`;

const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 5px;
  width: 100%;

  ${up(
    'lg',
    css`
      padding-top: 39px;
      flex-direction: column;
    `
  )}
`;

class Header extends Component {
  render() {
    return (
      <header className="site-header">
        {/* Leave the above <header /> here, necessary to contain Headroom */}
        {/* Otherwise Headroom will wrap all sibling elements */}
        <CustomHeadroom disableInlineStyles downTolerance={10}>
          <HeaderWrapper className="header-wrapper">
            <Grid>
              <Row>
                <Col lg={2}>
                  <LogoContainer>
                    <Link to="/">
                      <img src={HeaderLogo} alt="J.A. Russell Ltd" />
                    </Link>
                  </LogoContainer>
                </Col>
                <Col>
                  <HeaderRightContainer>
                    {this.props.children}
                  </HeaderRightContainer>
                </Col>
              </Row>
            </Grid>
          </HeaderWrapper>
        </CustomHeadroom>
      </header>
    );
  }
}

Header.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
};

Header.defaultProps = {
  children: undefined,
  theme: undefined,
};

export default withTheme(Header);
